import React from "react";

const About = ({ about }) => (
  <>
    <h5 className="font-header font-semibold text-front text-sm uppercase mb-3">About</h5>
    <div className="font-text text-sm pb-12 leading-normal whitespace-pre-line">
      The player winning most games in a session scores the number of games won by. Winning 6/4 scores 2 points, winning 6/3 4/1 = 10/4 scores 6 points. First player to a 100 points wins a champagne
      bottle at Boardwalk.
    </div>
  </>
);

export default About;
